import { render, staticRenderFns } from "./ProductDetailSales.vue?vue&type=template&id=deecc5d8&scoped=true&"
import script from "./ProductDetailSales.vue?vue&type=script&lang=js&"
export * from "./ProductDetailSales.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailSales.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductDetailSales.vue?vue&type=style&index=1&id=deecc5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deecc5d8",
  null
  
)

export default component.exports